import { render, staticRenderFns } from "./update-pause-job.vue?vue&type=template&id=2156165a"
import script from "./update-pause-job.vue?vue&type=script&lang=js"
export * from "./update-pause-job.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports